
// 根据六合号码，判断不同的背景颜色
export const filterNumber = (checkNumber) => {
  const redNumber = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
  const blueNumber = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
  const greenNumber = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
  if (redNumber.some(number => number == checkNumber )) return 'number-red';
  if (blueNumber.some(number => number == checkNumber )) return 'number-blue';
  if (greenNumber.some(number => number == checkNumber )) return 'number-green';
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/objectFactory.js